import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-success-popup',
    templateUrl: './success-popup.component.html',
    styleUrls: ['./success-popup.component.scss'],
    standalone: false
})
export class SuccessPopupComponent {
  constructor(public activeModal: NgbActiveModal) {}
}